import { connect } from 'react-redux'
import { change } from 'redux-form'
import { isEqual } from 'lodash'
import isEmpty from 'lodash/isEmpty'
import { compose, withProps, withState, withHandlers, lifecycle } from 'recompose'
import { show } from 'redux-modal'
import withType from 'components/common/hoc/withType'
import { injectProps } from 'helpers/utils'
import Appointment from '../../Appointment'
import { getTAOSAppointmentDatesAndSlots } from './actions'
import { APPOINTMENT_FORM_NAME, DATE_TIME_SELECTOR_FIELD_NAME } from 'constant'
import { setShowCallStorePromoExpirationNotification, setPromotionDetails } from 'components/ShoppingQuote/BOTProductAndServicesQuoteNew/components/PromotionExpirationModal/actions.js'
import { PROMOTION_EXPIRATION_MODAL } from '../BOTProductAndServicesQuoteNew/constants'
import { setModalWasShown } from '../BOTProductAndServicesQuoteNew/components/PromotionExpirationModal/actions'
import {
  getProductsCount,
  getCalendarStartDate
} from 'components/common/hoc/withAddToQuote/selectors'
import { getLatestAvailabilityDate } from 'components/ShoppingQuote/helpers.js'
import { getAppointmentDate } from 'selectors/getAppointments'
import { getUserData } from 'components/Appointment/selectors'
import {
  setCalendarStartDateForAddedSkus,
  resetCalendarStartDate
} from 'components/common/hoc/withAddToQuote/actions'
import { setDateData } from 'components/QuickAppointmentPage/actions'

const mapStateToProps = (state) => {
  const { isPilotStore } = getUserData(state)

  return {
    productsCount: getProductsCount(state),
    skusAddedToCart: state.addToQuote.skusAddedToCart,
    dates: getAppointmentDate(state),
    isPilotStore,
    calendarStartDate: getCalendarStartDate(state)
  }
}

const withTAOSDateTimeState = withState('appointmentDetailsResponseVO',
  'setAppointmentDetailsResponseVO',
  {
    appointmentDateAndSlotsVO: []
  })

const withTAOSDataLoading = withState('appointmentDataLoading', 'setAppointmentDataLoading', false)

const withHandleTAOSDateTimeUpdate = withHandlers({
  handleTAOSDateTimeUpdate: ({
    setAppointmentDetailsResponseVO,
    getTAOSAppointmentDatesAndSlots,
    setAppointmentDataLoading,
    updateFormField,
    setShowCallStorePromoExpirationNotification,
    setPromotionDetails,
    show,
    setModalWasShown,
    calendarStartDate
  }) => () => {
    setAppointmentDataLoading(true)
    getTAOSAppointmentDatesAndSlots(setAppointmentDataLoading, calendarStartDate)
      .then(({ appointmentDetailsResponseVO }) => {
        appointmentDetailsResponseVO && setAppointmentDetailsResponseVO(appointmentDetailsResponseVO)

        const { appointmentDatesNotInRangeOfPromoDates } = appointmentDetailsResponseVO

        if (appointmentDatesNotInRangeOfPromoDates) {
          const { promotionDetailsType } = appointmentDetailsResponseVO

          setShowCallStorePromoExpirationNotification(true)
          setPromotionDetails(promotionDetailsType)
          show(PROMOTION_EXPIRATION_MODAL, {
            appliedPromotions: promotionDetailsType,
            appointmentDatesNotInRangeOfPromoDates
          })
          setModalWasShown(true)
        }

        setAppointmentDataLoading(false)
        updateFormField(APPOINTMENT_FORM_NAME, DATE_TIME_SELECTOR_FIELD_NAME, {})
      })
  }
})

const withTAOSDateTimeProps = withProps(({
  appointmentDetailsResponseVO,
  handleTAOSDateTimeUpdate,
  appointmentDataLoading,
  placeholders: {
    mainContent = [],
    ...rest
  } = {}
}) => {
  const newMainContent = []
  mainContent.forEach(item => {
    if (item.props.type === 'BOTProductAndServicesQuote' || item.props.type === 'BOTShoppingCartQuote') {
      newMainContent.push(injectProps(item, { handleTAOSDateTimeUpdate })[0])
      return
    }
    if (item.props.type === 'BOTDateTimeSelector') {
      newMainContent.push(injectProps(item, { appointmentDetailsResponseVO, appointmentDataLoading }))
      return
    }

    const newItem = item.props.type === 'BOTAppointmentSummary'
      ? injectProps(item, { handleTAOSDateTimeUpdate })
      : item
    newMainContent.push(newItem)
  })
  return {
    placeholders: {
      mainContent: newMainContent,
      ...rest
    }
  }
})

const withLifeCycle = lifecycle({
  componentDidUpdate({
    skusAddedToCart: prevSkusAddedToCart,
    productsCount: prevProductsCount
  }) {
    const {
      calendarStartDate,
      handleTAOSDateTimeUpdate,
      productsCount,
      skusAddedToCart,
      dates,
      isPilotStore,
      setCalendarStartDateForAddedSkus,
      resetCalendarStartDate
    } = this.props

    if ((!isEqual(prevSkusAddedToCart, skusAddedToCart) || (!isEqual(productsCount, prevProductsCount)))
      && skusAddedToCart.length
      && (productsCount === skusAddedToCart.length)
      && isPilotStore) {
      const latestAvailabilityDate = getLatestAvailabilityDate(skusAddedToCart)

      latestAvailabilityDate && setCalendarStartDateForAddedSkus(latestAvailabilityDate)

      if (!latestAvailabilityDate) {
        resetCalendarStartDate()

        latestAvailabilityDate === calendarStartDate && handleTAOSDateTimeUpdate()
      }

      isEmpty(dates) && !latestAvailabilityDate && handleTAOSDateTimeUpdate()
    }
  },
  componentWillUnmount() {
    const { setDateData } = this.props

    setDateData(null)
  }
})

export default compose(
  withType({
    type: 'ShoppingQuoteOneColumnPage', placeholders: ['header', 'mainContent', 'footer']
  }),
  connect(mapStateToProps, {
    setShowCallStorePromoExpirationNotification,
    setPromotionDetails,
    setModalWasShown,
    show,
    getTAOSAppointmentDatesAndSlots,
    updateFormField: change,
    setCalendarStartDateForAddedSkus,
    setDateData,
    resetCalendarStartDate
  }),
  withTAOSDateTimeState,
  withTAOSDataLoading,
  withHandleTAOSDateTimeUpdate,
  withTAOSDateTimeProps,
  withLifeCycle
)(Appointment)
